import { propertyApi } from '@/api/index.js'
import {
  getForAutoComplete
} from '@/graphql_queries/property_management/property.js'

class PropertyApi {
  static getForAutoComplete (params) {
    return propertyApi.post('', {
      query: getForAutoComplete(params)
    })
  }
}

export default PropertyApi